// extracted by mini-css-extract-plugin
module.exports = {"back_btn_container":"BackBtn_back_btn_container__8MMoS","text_icon_container":"BackBtn_text_icon_container__vm9ip","back_btn_text":"BackBtn_back_btn_text__3GBEb"};